import { motion } from 'framer-motion';
import { useLang } from '@/context/LanguageContext';

const residencies = [
  { year: '2026', artists: ['La Mana', 'Remi Chabanael'] },
  { year: '2025', artists: ['Xam Hurricane', 'Barth', 'Tamo'] },
  { year: '2024', artists: ['Taomina', 'Sulafa', 'Eldegee', 'Two Faced Animals'] },
  { year: '2023', artists: ['Melys', 'Ooma', 'Paul Roman', 'Maeva'] },
  { year: '2022', artists: ['The CZ', 'Mandelbro', 'Torren'] },
];

const SummerChanceSection = () => {
  const { t } = useLang();

  return (
    <section data-testid="summer-chance-section" className="py-28 md:py-36 bg-[#F5F1EC]">
      <div className="px-5 md:px-10 lg:px-14 max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 md:mb-20"
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#E92A3E] mb-5">
            {t('summerChance.label')}
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#111] leading-tight mb-7">
            {t('summerChance.title')}
          </h2>
          <p className="text-base md:text-lg text-[#555] leading-relaxed max-w-2xl mx-auto">
            {t('summerChance.desc')}
          </p>
          <p className="text-sm text-[#888] leading-relaxed mt-3 max-w-md mx-auto">
            {t('summerChance.subdesc')}
          </p>
        </motion.div>

        <div className="border-t border-[#111]/15" data-testid="summer-chance-list">
          {residencies.map((r, i) => (
            <motion.div
              key={r.year}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 border-b border-[#111]/15 group"
              data-testid={`summer-chance-year-${r.year}`}
            >
              <div className="col-span-12 md:col-span-4">
                <p className="font-heading font-bold text-4xl md:text-6xl text-[#E92A3E] leading-none tracking-tight">
                  {r.year}
                </p>
              </div>
              <div className="col-span-12 md:col-span-8 flex flex-wrap items-center gap-x-3 gap-y-2">
                {r.artists.map((name, j) => (
                  <span key={name} className="inline-flex items-center">
                    <span className="font-heading text-lg md:text-2xl text-[#111] leading-tight">
                      {name}
                    </span>
                    {j < r.artists.length - 1 && (
                      <span className="ml-3 text-[#111]/30 text-lg md:text-2xl">·</span>
                    )}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SummerChanceSection;
